<template>
  <div aria-live="off" role="alert">
    <div class="status-container margins-off">
      <div class="status" :class="statusClassModifier">
        <transition name="flipup" mode="out-in">
          <div v-bind:key="message">{{ message }}</div>
        </transition>
      </div>
      <span v-if="hasResponse" class="updated-at">
        <span class="visually-hidden">Updated</span>
        @ {{ lastUpdated }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasResponse: Boolean,
    status: {
      type: String,
      // Status must be one of three values. Is this necessary? Could it be enforced elsewhere?
      validator: function(value) {
        return ["locating", "located", "error"].indexOf(value) !== -1;
      }
    },
    time: Date,
    isWatching: Boolean
  },

  computed: {
    message: function() {
      if (this.isWatching) return "Watching";

      switch (this.status) {
        case "locating":
          return "Scanning …";
        case "located":
          return "Located";
        case "error":
          return "Error";
        default:
          return "¯\\_(ツ)_/¯";
      }
    },

    lastUpdated: function() {
      return this.time.toLocaleTimeString(navigator.language, {
        hour: "2-digit",
        minute: "2-digit"
      });
    },

    statusClassModifier: function() {
      if (this.isWatching) return "tracking";
      return this.status;
    }
  }
};
</script>

<style lang="scss">
.status-container {
  align-items: baseline;
  display: flex;
  justify-content: space-between;
}

.status {
  background-color: $color-purple-highlight;
  border-radius: 20px;
  display: inline-block;
  font-weight: 700;
  margin-left: -0.625em;
  padding: 0.125em 0.625em;
  transition: all 0.4s ease;

  &.error {
    background-color: red;
  }

  &.locating,
  &.tracking {
    background-color: $color-accent;
    color: $color-purple;
  }
}

.updated-at {
  font-size: 0.75em;
}
</style>
